import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Table from "@mui/material/Table/Table";
import Paper from "@mui/material/Paper";
import { getDisplayDateFrShort } from "../time";
import { Component } from "react";

class ActivityReportList extends Component {
    render() {
        let amplitude = 0;
        let perso = 0;
        let trajet = 0;
        let tte = 0;
        let indemnite_dejeuner = 0;
        let nb_dejeuner_autre = 0;
        let indemnite_deplacement = 0;
        let permanence_astreinte = 0;
        let casse_croute = 0;
        let nuit = 0;
        let key = 0;

        let cellStyle = {
            maxWidth: (100 / 8).toString() + "%",
            paddingLeft: "0px",
            paddingRight: "0px",
            textAlign: "center",
            margin: "auto",
            background: "#FFFFFF",
            color: "#005bba",
        };

        let totalStyle = Object.assign({}, cellStyle);
        let titleStyle = Object.assign({}, cellStyle);
        let days = [];

        totalStyle.background = "#33488c";
        totalStyle.color = "#FFFFFF";

        titleStyle.background = "#005bba";
        titleStyle.color = "#FFFFFF";

        if (this.props.days) {
            for (let i = 0; i < this.props.days.length; i++) {
                if (this.props.days[i].week_name === this.props.week) {
                    days.push(this.props.days[i]);
                }
            }
        }

        days.sort((a, b) => {
            return a.date > b.date ? -1 : a.date < b.date ? 1 : 0;
        });

        let body = days.map(function (day) {
            let localStyle = Object.assign({}, cellStyle);

            localStyle.background = key % 2 === 1 ? "#FFFFFF" : "#d9d9db";
            amplitude += Number.isNaN(day.amplitude) ? 0 : parseFloat(day.amplitude);
            perso += Number.isNaN(day.temps_perso) ? 0 : parseFloat(day.temps_perso);
            trajet += Number.isNaN(day.trajet) ? 0 : parseFloat(day.trajet);
            tte += Number.isNaN(day.tte) ? 0 : parseFloat(day.tte);
            indemnite_dejeuner += Number.isNaN(day.indemnite_dejeuner) ? 0 : parseFloat(day.indemnite_dejeuner);
            nb_dejeuner_autre += Number.isNaN(day.nb_dejeuner_autre) ? 0 : parseFloat(day.nb_dejeuner_autre);
            indemnite_deplacement += Number.isNaN(day.igd) ? 0 : parseFloat(day.igd);
            permanence_astreinte += Number.isNaN(day.astreinte) ? 0 : parseFloat(day.astreinte);
            casse_croute += Number.isNaN(day.casse_croute) ? 0 : day.casse_croute;
            nuit += Number.isNaN(day.nuit_dim_ferie) ? 0 : day.nuit_dim_ferie;

            return (
                <TableRow key={key++} style={{ width: "100%" }}>
                    <TableCell style={localStyle} component="th" scope="row">
                        {getDisplayDateFrShort(day.date)}
                    </TableCell>
                    <TableCell style={localStyle} align="right">
                        {Number.isNaN(day.amplitude) ? "" : day.amplitude.toFixed(2)}
                    </TableCell>
                    <TableCell style={localStyle} align="right">
                        {Number.isNaN(day.temps_perso) ? "" : day.temps_perso.toFixed(2)}
                    </TableCell>
                    <TableCell style={localStyle} align="right">
                        {Number.isNaN(day.trajet) ? "" : day.trajet.toFixed(2)}
                    </TableCell>
                    <TableCell style={localStyle} align="right">
                        {Number.isNaN(day.tte) ? "" : day.tte.toFixed(2)}
                    </TableCell>
                    <TableCell style={localStyle} align="right">
                        {Number.isNaN(day.nuit_dim_ferie) ? "" : day.nuit_dim_ferie.toFixed(2)}
                    </TableCell>
                    <TableCell style={localStyle} align="right">
                        {Number.isNaN(day.igd) ? "" : parseFloat(day.igd).toFixed(0)}
                    </TableCell>
                    <TableCell style={localStyle} align="right">
                        {Number.isNaN(day.indemnite_dejeuner) ? "" : parseFloat(day.indemnite_dejeuner).toFixed(0)}
                    </TableCell>
                    <TableCell style={localStyle} align="right">
                        {Number.isNaN(day.nb_dejeuner_autre) ? "" : parseFloat(day.nb_dejeuner_autre).toFixed(0)}
                    </TableCell>
                    <TableCell style={localStyle} align="right">
                        {Number.isNaN(day.astreinte) ? "" : parseFloat(day.astreinte).toFixed(0)}
                    </TableCell>
                    <TableCell style={localStyle} align="right">
                        {Number.isNaN(day.casse_croute) ? "" : day.casse_croute.toFixed(2)}
                    </TableCell>
                </TableRow>
            );
        });

        return (
            <Paper
                elevation={4}
                style={{
                    width: "98%",
                    marginLeft: "auto",
                    marginRight: "auto",
                    marginTop: "10px",
                    marginBottom: "10px",
                }}
            >
                <div style={{ fontSize: 22, color: "#005bba" }}>SEMAINE {this.props.week}</div>
                {days.length > 0 ? (
                    <Table style={{ width: "100%" }}>
                        <TableHead style={{ width: "100%" }}>
                            <TableRow style={{ width: "100%" }}>
                                <TableCell style={titleStyle} />
                                <TableCell style={titleStyle}>{"Amplitude"}</TableCell>
                                <TableCell style={titleStyle}>{"Perso"}</TableCell>
                                <TableCell style={titleStyle}>{"Trajet"}</TableCell>
                                <TableCell style={titleStyle}>{"TTE"}</TableCell>
                                <TableCell style={titleStyle}>{"Nuit /Dim/Férié"}</TableCell>
                                <TableCell style={titleStyle}>{"IGD"}</TableCell>
                                <TableCell style={titleStyle}>{"Ind. Déj"}</TableCell>
                                <TableCell style={titleStyle}>{"Repas -10km"}</TableCell>
                                <TableCell style={titleStyle}>{"PN/AS"}</TableCell>
                                <TableCell style={titleStyle}>{"Casse-Croute"}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody style={{ width: "100%" }}>
                            {body}
                            <TableRow key={key++} style={{ width: "100%" }}>
                                <TableCell style={totalStyle} component="th" scope="row">
                                    {"TOTAL"}
                                </TableCell>
                                <TableCell style={totalStyle} align="right">
                                    {amplitude.toFixed(2)}
                                </TableCell>
                                <TableCell style={totalStyle} align="right">
                                    {perso.toFixed(2)}
                                </TableCell>
                                <TableCell style={totalStyle} align="right">
                                    {trajet.toFixed(2)}
                                </TableCell>
                                <TableCell style={totalStyle} align="right">
                                    {tte.toFixed(2)}
                                </TableCell>
                                <TableCell style={totalStyle} align="right">
                                    {nuit.toFixed(2)}
                                </TableCell>
                                <TableCell style={totalStyle} align="right">
                                    {parseFloat(indemnite_deplacement).toFixed(0)}
                                </TableCell>
                                <TableCell style={totalStyle} align="right">
                                    {parseFloat(indemnite_dejeuner).toFixed(0)}
                                </TableCell>
                                <TableCell style={totalStyle} align="right">
                                    {parseFloat(nb_dejeuner_autre).toFixed(0)}
                                </TableCell>
                                <TableCell style={totalStyle} align="right">
                                    {parseFloat(permanence_astreinte).toFixed(0)}
                                </TableCell>
                                <TableCell style={totalStyle} align="right">
                                    {casse_croute.toFixed(2)}
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                ) : null}
            </Paper>
        );
    }
}

export default ActivityReportList;
